import { DefineComponent, FunctionalComponent } from "vue";
import { VueDashboardItemClasses } from "../skyVue/dashboardItem/classes";

type ResizeHandleProps =
    {
        color?: string;
    };

const ResizeHandle: FunctionalComponent<ResizeHandleProps> = function vResizeHandle(props: ResizeHandleProps, _context)
{
    // Keep in sync with .vueDashboardItem__resizeHandle in VueDashboardItemPartial.cs
    const resizeHandleStyle = `background:` +
        `linear-gradient(135deg, transparent 60%, ${props.color} 60%, ${props.color} 70%, transparent 70%, transparent 80%, ${props.color} 80%, ${props.color} 90%, transparent 90%)`

    return (
        <>
            <div class={`ui-resizable-handle ${VueDashboardItemClasses.ResizeHandle} `} style={resizeHandleStyle} />
            <div class="ui-resizable-handle ui-resizable-e" />
            <div class="ui-resizable-handle ui-resizable-s" />
        </>
    );
};

ResizeHandle.props = ["color"];
export default ResizeHandle as unknown as DefineComponent<ResizeHandleProps, JSX.Element>;
